<template>
  <div id="app">
    
      <router-link to="/compere"></router-link>
      <router-link to="/programPage"></router-link>
      <router-link to="/liveStreaming"></router-link>
      <router-link to="/programStop"></router-link>
      <router-link to="/programRecorded"></router-link>
      <router-link to="/lifeLive"></router-link>
      <router-link to="/ratePage"></router-link>
      <router-link to="/programRecordedNew"></router-link>
      <router-link to="/compereNew"></router-link>

      <toast></toast>
      <!-- <loading></loading> -->
      <router-view  v-wechat-title="$route.meta.title"/>
      
    
  </div>
</template>

<script>

import cbct from  './../static/js/base.js'
import Vue from 'vue'
import Axios from 'axios'
import toast from '@/components/commen/toast'
// import loading from '@/components/commen/loading'
// import '../static/css/font/font.css'
Vue.prototype.$http=Axios

export default {
  name: 'app',
  components: {
    toast,
    // loading
  }
}
</script>

<style>
*{
  padding: 0px;
  margin: 0px;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

</style>
